// Client-submitted documents on the case page. The lawyer backend renders each
// preview (a PDF's first page, or the image itself) as a small JPEG.

import { request, requestBlob } from './client';

export const fetchDocumentThumbnail = (token: string, caseId: string, documentId: string): Promise<Blob> =>
  requestBlob(
    token,
    `/cases/${encodeURIComponent(caseId)}/documents/${encodeURIComponent(documentId)}/thumbnail`,
    'Could not load the document preview'
  );

// The cleaned page that document-scan-service derived from a proof-of-address
// photo (recorded on the file as `scan`). A portal-only preview: the original
// stays the document of record and the download package never includes it.
export const fetchDocumentScanThumbnail = (token: string, caseId: string, documentId: string): Promise<Blob> =>
  requestBlob(
    token,
    `/cases/${encodeURIComponent(caseId)}/documents/${encodeURIComponent(documentId)}/scan/thumbnail`,
    'Could not load the cleaned page preview'
  );

export const fetchDocumentScanSignedUrl = (token: string, caseId: string, documentId: string): Promise<{ url: string }> =>
  request(
    token,
    `/cases/${encodeURIComponent(caseId)}/documents/${encodeURIComponent(documentId)}/scan/signed-url`,
    { method: 'GET' },
    'Could not open the cleaned page'
  );

// A minor's case: the lawyer's answer to the automatic check that the parents
// on the birth certificate are the guardians who sent their documents. An
// empty value clears it.
export interface GuardianMatchOverrideResult {
  guardian_match_override: { value: string; reason: string; by?: string | null } | null;
  changed: boolean;
}

export const setGuardianMatchOverride = (
  token: string,
  caseId: string,
  value: string,
  reason: string
): Promise<GuardianMatchOverrideResult> =>
  request(
    token,
    `/cases/${encodeURIComponent(caseId)}/guardian-match-override`,
    { method: 'PUT', body: JSON.stringify({ value, reason }) },
    'Failed to save the guardian check override.'
  );
